var _templateObject;

function _taggedTemplateLiteralLoose(strings, raw) { if (!raw) { raw = strings.slice(0); } strings.raw = raw; return strings; }

import styled from 'styled-components';
import Dialog from '../../Dialog';
var Content = styled(Dialog.Content)(_templateObject || (_templateObject = _taggedTemplateLiteralLoose(["\n  ", "\n  margin: 0;\n  height: 100%;\n  width: 100%;\n  align-self: flex-start;\n  text-align: left;\n"])), function (_ref) {
  var drawer = _ref.theme.yoga.components.drawer;
  return "\n    ";
});
Content.displayName = 'Drawer.Content';
export default Content;